// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"414d148e","513":"f17d5ed3","703":"5a9d7ba5"}[chunkId] + ".chunk.js";
};